module.exports = __webpack_public_path__ + "static/50-electricityuse-august2025-2243910602de4fc2ccfe82bd8e97b53a.jpg";